import {Component, forwardRef, Inject, Injector} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ClientService} from '../../services/client.service';
import {AlertService} from '../../services/alert.service';
import {SessionService} from '../../services/session.service';
import {TranslateService} from '@ngx-translate/core';
import {EmployeeTimesheetLine} from '../../model/EmployeeTimesheetLine';

import {ExplainBreak} from "./ExplainBreak";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {EmployeeHoraire} from "../../model/EmployeHoraire";
import {Utils} from "../../model/Utils";

@Component({
  templateUrl: './BreaksTimesheetComponent.html'
})

export class BreaksTimesheetComponent{

  line: EmployeeTimesheetLine;

  currentEmployeeHoraire: EmployeeHoraire;

  constructor (private injector: Injector,
               @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
               @Inject(forwardRef(() => ClientService)) private clientService: ClientService,
               @Inject(forwardRef(() => DomSanitizer)) private domSanitizer: DomSanitizer,
               @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
               @Inject(forwardRef(() => SessionService)) private session: SessionService,
               @Inject(forwardRef(() => TranslateService)) private translate: TranslateService) {
    this.line = this.injector.get('line');
    this.currentEmployeeHoraire = this.line.retrieveCurrentEmployeeHoraire();
    this._validate();
  }


  private _validate() {
    this.line.validateBreak1(this.translate);
    this.line.validateBreak2(this.translate);
  }

  retrieveBreak1(){
    let breakMustBePaid = this.line.breaksArePaidEvenWhenNotScheduled;

    if (!breakMustBePaid){
      breakMustBePaid = this.currentEmployeeHoraire.break1MustBePaid;
    }
    return this.currentEmployeeHoraire.retrieveMinuteRemovedFromBreak1(this.line.normalBreakDuration,breakMustBePaid);
  }

  retrieveBreak2(){
    let breakMustBePaid = this.line.breaksArePaidEvenWhenNotScheduled;

    if (!breakMustBePaid){
      breakMustBePaid = this.currentEmployeeHoraire.break2MustBePaid;
    }

    return this.currentEmployeeHoraire.retrieveMinuteRemovedFromBreak2(this.line.normalBreakDuration,breakMustBePaid);
  }


  needToSpecifyHours(): boolean{
    let res = true;
    if (!Utils.isNullOrUndefined(this.currentEmployeeHoraire.tsType)){
      res = this.currentEmployeeHoraire.tsType.needsToSpecifyHours()
    }
    this.line.break1Validation.applyStyle=res;
    this.line.break2Validation.applyStyle=res;
    return res;
  }


  public hasBreak1Info(): boolean {
    // console.log('hasBreak1Info ' + this.needToSpecifyHours() + ' ' + JSON.stringify(this.currentEmployeeHoraire,null,1));
    // console.log('hasBreak1Info ');
    if (this.currentEmployeeHoraire.tsBreak1>0){
      // console.log('hasBreak1Info 1');
      return true;
    }
    if (!this.needToSpecifyHours()){
      // console.log('hasBreak1Info 2');
      return false;
    }
    if (! this.currentEmployeeHoraire.sdBreak1Start) {
      if (! this.currentEmployeeHoraire.tsBreak1StartPunchDt) {
        if (! this.currentEmployeeHoraire.tsBreak1EndPunchDt) {
          // console.log('hasBreak1Info 3');
          return false;
        }
      }
    }

    /*
    if (this.currentEmployeeHoraire.tsBreak1PunchAdj>0){
      console.log('hasBreak1Info 4 ' + this.currentEmployeeHoraire.tsBreak1PunchAdj);
      return false;
    }
    */

    // if (this.currentEmployeeHoraire.tsBreak1>0){
    //   return true;
    // }

    // console.log('break1 Info');
    return true;
  }

  public hasBreak2Info(): boolean {
    if (this.currentEmployeeHoraire.tsBreak2>0){
      return true;
    }
    if (!this.needToSpecifyHours()){
      return false;
    }


    if (! this.currentEmployeeHoraire.sdBreak2Start) {
      if (! this.currentEmployeeHoraire.tsBreak2StartPunchDt) {
        if (! this.currentEmployeeHoraire.tsBreak2EndPunchDt) {
          // console.log('break2 Info No break2 ');
          return false;
        }
      }
    }

    // console.log('break2 Info');
    return true;
  }

  public explainBreak1():SafeHtml{
    // const displayMinute = new DisplayMinute();
//    console.log('Explaining Break1 ' + this.currentEmployeeHoraire.retrieveMinuteRemovedFromBreak1(this.line.normalBreakDuration));
    const explainBreak = new ExplainBreak(this.domSanitizer,this.translate);

    let breakMustBePaid = this.line.breaksArePaidEvenWhenNotScheduled;

    if (!breakMustBePaid){
      breakMustBePaid = this.currentEmployeeHoraire.break1MustBePaid;
    }

    return explainBreak.explainBreak(breakMustBePaid,this.line.normalBreakDuration,
      this.currentEmployeeHoraire.tsBreak1PunchAdj,this.currentEmployeeHoraire.retrieveMinuteRemovedFromBreak1(this.line.normalBreakDuration,breakMustBePaid));
  }


  public explainBreak2():SafeHtml{
    // const displayMinute = new DisplayMinute();
    const explainBreak = new ExplainBreak(this.domSanitizer,this.translate);

    let breakMustBePaid = this.line.breaksArePaidEvenWhenNotScheduled;

    if (!breakMustBePaid){
      breakMustBePaid = this.currentEmployeeHoraire.break2MustBePaid;
    }


    return explainBreak.explainBreak(breakMustBePaid,this.line.normalBreakDuration,
      this.currentEmployeeHoraire.tsBreak2PunchAdj,
      this.currentEmployeeHoraire.retrieveMinuteRemovedFromBreak2(this.line.normalBreakDuration,breakMustBePaid));

  }



}
